import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { allDomainNames } from "src/main/contants";
import { checkWithOrWithoutWWW } from "src/main/utils";

export interface PreferenceState {
  language: string | null;
  // storedLoginPhone: string | null;
}

const LANG_KEY = "lng";
// const STORED_MOBILE_KEY = "ILV_STORED_LOGIN_PHONE";

const getPersisLanguage = () => {
  try {
    const savedLanguage = localStorage.getItem(LANG_KEY);
    let th_map = allDomainNames.TH;
    let isTh = false;
    const hostname = window.location.hostname ?? "";
    Object.values(th_map).forEach((th_domain) => {
      if (checkWithOrWithoutWWW(th_domain, hostname)) {
        isTh = true;
      }
    });

    if (savedLanguage) return savedLanguage;
    else {
      if (isTh) {
        return "th";
      }
    }

    return "en";
  } catch (error) {
    return "en";
  }
};

// const getStoredLoginPhone = () => {
//   try {
//     const number = localStorage.getItem(STORED_MOBILE_KEY);
//     if (!!number) return number;
//     return null;
//   } catch (error) {
//     return null;
//   }
// };

const initialState: PreferenceState = {
  language: getPersisLanguage(),
  // storedLoginPhone: getStoredLoginPhone(),
};

const preferenceSlice = createSlice({
  name: "@preference",
  initialState,
  reducers: {
    setLanguage(state, action: PayloadAction<string>) {
      state.language = action.payload;
      localStorage.setItem(LANG_KEY, state.language);
    },
    // setLoginPhone(state, action: PayloadAction<string>) {
    //   state.storedLoginPhone = action.payload;
    //   localStorage.setItem(STORED_MOBILE_KEY, state.storedLoginPhone);
    // }
  },
});

export default preferenceSlice;
